var _rect, _rect2, _path, _rect3, _rect4, _rect5, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDecisionTreeOperationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 6,
    fill: "#272D55"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 17.6665,
    y: 4,
    width: 4.66667,
    height: 8.52632,
    rx: 2.33333,
    fill: "#E3ECFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.6665 22V22C32.6665 20.0815 31.1113 18.5263 29.1928 18.5263L10.8069 18.5263C8.8884 18.5263 7.33317 20.0815 7.33317 22V22",
    stroke: "#E3ECFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 17.6665,
    y: 25.4736,
    width: 4.66667,
    height: 8.52632,
    rx: 2.33333,
    fill: "#E3ECFF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 30.3335,
    y: 25.4736,
    width: 4.66667,
    height: 8.52632,
    rx: 2.33333,
    fill: "#E3ECFF"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 25.4736,
    width: 4.66667,
    height: 8.52632,
    rx: 2.33333,
    fill: "#E3ECFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 22L20 15.3684",
    stroke: "#E3ECFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecisionTreeOperationIcon);
export default __webpack_public_path__ + "static/media/DecisionTreeOperationIcon.fe25b1a686159f3858b12634772f3dc0.svg";
export { ForwardRef as ReactComponent };